import { getToken } from "../../../services/authService";

export const API_BASE = process.env.REACT_APP_API_URL || "";

export const apiUrl = (path) =>
    `${API_BASE.replace(/\/+$/, "")}/${String(path).replace(/^\/+/, "")}`;

export const authHeaders = () => {
    const token = getToken();
    return { Authorization: `Bearer ${token}` };
};

export const authJsonHeaders = () => ({
    ...authHeaders(),
    "Content-Type": "application/json",
});
